module.exports = __webpack_public_path__ + "static/media/OrderMt.b77c698b.svg";